export const categories = [
  {
    id: 1,
    name: '恋爱甜宠',
    slug: 'romance',
    description: '甜蜜浪漫的韩国恋爱漫画，温暖治愈每一颗心',
  },
  {
    id: 2,
    name: '热血动作',
    slug: 'action',
    description: '热血沸腾的动作韩漫，感受极致战斗快感',
  },
  {
    id: 3,
    name: '悬疑惊悚',
    slug: 'thriller',
    description: '紧张刺激的悬疑韩漫，烧脑剧情层层反转',
  },
  {
    id: 4,
    name: '奇幻冒险',
    slug: 'fantasy',
    description: '天马行空的奇幻世界，开启异世界冒险之旅',
  },
  {
    id: 5,
    name: '都市生活',
    slug: 'urban',
    description: '都市爱情与职场生活，贴近现实的韩漫故事',
  },
  {
    id: 6,
    name: '古风华韵',
    slug: 'historical',
    description: '唯美古风韩国漫画，穿越时空的浪漫邂逅',
  },
];

export const comics = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    author: '金智恩',
    categoryId: 1,
    categoryName: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20clean%20illustration%20with%20delicate%20linework%2C%20pastel%20tones%2C%20romantic%20atmosphere%2C%20professional%20digital%20art%2C%20simple%20gradient%20background%20with%20soft%20pink%20and%20cream%20tones&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    description: '为救家族企业，她签下了一份契约婚姻。本以为只是一场交易，却在相处中渐渐沦陷。霸道总裁的温柔，只有她看得见。',
    rating: 9.6,
    views: 1285000,
    status: '连载中',
    updatedAt: '2026-07-06',
    tags: ['契约婚姻', '霸道总裁', '先婚后爱', '甜蜜'],
  },
  {
    id: 2,
    title: '暗夜王者',
    author: '朴俊赫',
    categoryId: 2,
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20dark%20warrior%20character%20with%20intense%20expression%2C%20dramatic%20lighting%20from%20above%2C%20dynamic%20pose%2C%20clean%20illustration%20style%2C%20deep%20crimson%20and%20black%20color%20scheme%2C%20professional%20digital%20art%2C%20simple%20dark%20gradient%20background&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    description: '他是黑夜的主宰，地下世界的无冕之王。当黑暗势力再次蠢蠢欲动，他选择用拳头守护珍视的一切。',
    rating: 9.4,
    views: 986000,
    status: '已完结',
    updatedAt: '2026-06-28',
    tags: ['格斗', '黑帮', '热血', '复仇'],
  },
  {
    id: 3,
    title: '第七夜的秘密',
    author: '李慧珍',
    categoryId: 3,
    categoryName: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mysterious%20atmosphere%20with%20a%20single%20figure%20in%20shadow%2C%20foggy%20dark%20alley%2C%20moody%20blue-gray%20tones%2C%20cinematic%20lighting%2C%20clean%20digital%20illustration%2C%20professional%20art%2C%20simple%20dark%20gradient%20background&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    description: '连续七夜的离奇命案，每一具尸体旁都留下了一枚古老硬币。刑警韩素希必须在下一个第七夜到来前，揭开真相。',
    rating: 9.7,
    views: 752000,
    status: '连载中',
    updatedAt: '2026-07-05',
    tags: ['推理', '悬疑', '警匪', '连环案件'],
  },
  {
    id: 4,
    title: '剑与魔法之境',
    author: '崔在贤',
    categoryId: 4,
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20epic%20sword%20and%20magic%20theme%2C%20heroic%20character%20with%20glowing%20sword%2C%20magical%20particles%20floating%2C%20dramatic%20golden%20and%20emerald%20tones%2C%20clean%20digital%20illustration%2C%20professional%20art%2C%20simple%20warm%20gradient%20background&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    description: '平凡高中生意外穿越到剑与魔法的世界。在这里，他发现自己拥有独一无二的"禁忌之力"，命运的齿轮开始转动。',
    rating: 9.5,
    views: 1100000,
    status: '连载中',
    updatedAt: '2026-07-07',
    tags: ['异世界', '魔法', '剑术', '成长'],
  },
  {
    id: 5,
    title: '首尔深夜食堂',
    author: '尹秀雅',
    categoryId: 5,
    categoryName: '都市生活',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20late%20night%20restaurant%20scene%2C%20warm%20yellow%20lighting%20from%20inside%2C%20urban%20Seoul%20street%20at%20night%2C%20nostalgic%20atmosphere%2C%20clean%20illustration%20style%2C%20professional%20digital%20art%2C%20simple%20warm%20dark%20background&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    description: '深夜的首尔街头，一家不起眼的小食堂亮着温暖的灯光。每个走进这里的人，都带着自己的故事。',
    rating: 9.3,
    views: 645000,
    status: '已完结',
    updatedAt: '2026-06-15',
    tags: ['美食', '治愈', '都市', '人生百态'],
  },
  {
    id: 6,
    title: '花间一壶酒',
    author: '朴素妍',
    categoryId: 6,
    categoryName: '古风华韵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20romance%20cover%20art%2C%20beautiful%20hanbok%20clad%20woman%20in%20traditional%20Korean%20garden%2C%20cherry%20blossoms%20falling%2C%20soft%20watercolor%20style%2C%20elegant%20pastel%20pink%20and%20cream%20tones%2C%20professional%20digital%20art%2C%20simple%20light%20gradient%20background&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    description: '朝鲜时代，一位酿酒名家的女儿与微服私访的王子在花间相遇。一壶酒，一段情，一曲乱世离歌。',
    rating: 9.8,
    views: 832000,
    status: '连载中',
    updatedAt: '2026-07-04',
    tags: ['古风', '宫廷', '浪漫', '历史'],
  },
  {
    id: 7,
    title: '猎魔人笔记',
    author: '姜道贤',
    categoryId: 4,
    categoryName: '奇幻冒险',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20hunter%20cover%20art%2C%20dark%20fantasy%20theme%2C%20mysterious%20hunter%20with%20ancient%20book%2C%20supernatural%20energy%20effects%2C%20deep%20purple%20and%20silver%20tones%2C%20clean%20digital%20illustration%2C%20professional%20art%2C%20simple%20dark%20gradient%20background&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    description: '隐藏在都市阴影中的猎魔人，用古老的秘术对抗来自异界的邪恶。一本泛黄的笔记，记录着世代猎魔人的血与泪。',
    rating: 9.2,
    views: 578000,
    status: '连载中',
    updatedAt: '2026-07-03',
    tags: ['猎魔', '都市奇幻', '秘术', '战斗'],
  },
  {
    id: 8,
    title: '校园梦游记',
    author: '韩智浩',
    categoryId: 1,
    categoryName: '恋爱甜宠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20youthful%20couple%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20bright%20spring%20colors%2C%20fresh%20and%20vibrant%20atmosphere%2C%20clean%20illustration%20style%2C%20professional%20digital%20art%2C%20simple%20light%20gradient%20background&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    description: '转学第一天，她就在教室门口撞到了全校最受欢迎的男生。一个关于青春、梦想和初恋的故事。',
    rating: 9.1,
    views: 920000,
    status: '已完结',
    updatedAt: '2026-05-20',
    tags: ['校园', '初恋', '青春', '甜宠'],
  },
  {
    id: 9,
    title: '末路狂花',
    author: '金荷娜',
    categoryId: 2,
    categoryName: '热血动作',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20female%20lead%20cover%20art%2C%20strong%20woman%20in%20leather%20jacket%20on%20motorcycle%2C%20urban%20night%20street%20with%20neon%20lights%2C%20cool%20and%20edgy%20atmosphere%2C%20clean%20illustration%2C%20professional%20digital%20art%2C%20simple%20dark%20gradient%20background&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
    description: '她曾是首尔最顶尖的女特工，如今却成了被组织追杀的目标。骑上机车，一路狂飙，只为活下去。',
    rating: 9.4,
    views: 713000,
    status: '连载中',
    updatedAt: '2026-07-01',
    tags: ['特工', '动作', '女性主角', '逃亡'],
  },
  {
    id: 10,
    title: '星之回响',
    author: '朴敏雅',
    categoryId: 3,
    categoryName: '悬疑惊悚',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20mystery%20cover%20art%2C%20star-filled%20night%20sky%20with%20silhouette%20of%20a%20person%2C%20dreamlike%20ethereal%20atmosphere%2C%20cool%20indigo%20and%20silver%20tones%2C%20clean%20digital%20illustration%2C%20professional%20art%2C%20simple%20dark%20gradient%20background&width=800&height=1067&seq=comic-cover-10&orientation=portrait',
    description: '每当流星划过，就会有人离奇失踪。天文台实习生李星河发现，这一切都与二十年前的一场实验有关。',
    rating: 9.0,
    views: 489000,
    status: '连载中',
    updatedAt: '2026-07-02',
    tags: ['心理悬疑', '科幻', '失踪', '天文'],
  },
  {
    id: 11,
    title: '邻里之间',
    author: '郑多惠',
    categoryId: 5,
    categoryName: '都市生活',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20neighborhood%20comedy%20cover%20art%2C%20colorful%20apartment%20building%20with%20quirky%20characters%2C%20bright%20and%20lively%20colors%2C%20warm%20and%20funny%20vibe%2C%20clean%20illustration%20style%2C%20professional%20digital%20art%2C%20simple%20light%20gradient%20background&width=800&height=1067&seq=comic-cover-11&orientation=portrait',
    description: '首尔某小区的五个邻居，性格迥异，却因为各种乌龙事件被命运紧紧绑在一起。笑中带泪的都市喜剧。',
    rating: 9.3,
    views: 560000,
    status: '连载中',
    updatedAt: '2026-07-06',
    tags: ['喜剧', '邻里', '都市', '群像'],
  },
  {
    id: 12,
    title: '绯红姻缘',
    author: '崔允书',
    categoryId: 6,
    categoryName: '古风华韵',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%20art%2C%20elegant%20crimson%20hanbok%20woman%20in%20palace%20courtyard%2C%20dramatic%20traditional%20Korean%20architecture%20background%2C%20rich%20red%20and%20gold%20color%20palette%2C%20clean%20digital%20illustration%2C%20professional%20art%2C%20simple%20warm%20gradient%20background&width=800&height=1067&seq=comic-cover-12&orientation=portrait',
    description: '她是朝鲜最出色的绣娘，一针一线绣出了自己的命运。当她被召入宫中，一场围绕着权力与爱情的博弈悄然展开。',
    rating: 9.6,
    views: 690000,
    status: '已完结',
    updatedAt: '2026-04-10',
    tags: ['宫廷', '刺绣', '权谋', '爱情'],
  },
];

export const featuredComics = [1, 3, 4, 6, 9, 12];

export const hotComics = [2, 4, 7, 8, 10, 11];

export const newComics = [1, 5, 7, 9, 10, 11];